import { h } from 'preact'
import ButtonControl from '../button-control'

interface Props {
  value: string,
  placeholder?: string,
  onSubmit: Function
}

function handleSubmit (event: Event, onSubmit: Function) {
  event.preventDefault()

  const { target } = event
  const input = (target as HTMLElement).querySelector('input')

  if(!input) return

  const value = input.value.trim()

  if (!value) return

  onSubmit(value)
}

const SearchBox = ({ value, placeholder, onSubmit }: Props) => {
  return <div class='control-search-box'>
    <form onSubmit={(event => handleSubmit(event, onSubmit))}>
      <input
          class='qa-search-box-filter'
          type='text'
          value={value}
          placeholder={placeholder}
          maxLength={500}
      />
      <ButtonControl variant='primary' type='submit' icon='search' />
    </form>
  </div>
}

export default SearchBox
